export function DoneOrRemoveManualFollowUp(this: any) {
  return {
    followupDataId: this?.key,
    action: this?.action?.toLowerCase(),
    comment: this?.comment,
  };
}
